import { Link, useLocation } from "react-router-dom";
import { Home, Search, PlusCircle, Heart, User } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { cn } from "@/lib/utils";

interface TabItem {
  to: string;
  icon: typeof Home;
  label: string;
  requiresAuth?: boolean;
}

const BottomTabBar = () => {
  const location = useLocation();
  const { user } = useAuth();

  const tabs: TabItem[] = [
    { to: "/", icon: Home, label: "Home" },
    { to: "/listings", icon: Search, label: "Browse" },
    { to: "/list-property", icon: PlusCircle, label: "List" },
    { to: "/my-perch", icon: Heart, label: "My Perch", requiresAuth: true },
    { to: user ? "/settings" : "/auth", icon: User, label: user ? "Account" : "Sign In" },
  ];

  const visibleTabs = tabs.filter(tab => !tab.requiresAuth || user);

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border/40 safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {visibleTabs.map((tab) => {
          const active = isActive(tab.to);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={cn(
                "flex flex-col items-center justify-center flex-1 h-full min-h-[44px] min-w-[44px] gap-0.5 transition-colors touch-manipulation",
                active 
                  ? "text-accent" 
                  : "text-muted-foreground hover:text-primary"
              )}
            >
              <tab.icon className={cn("w-5 h-5", active && "stroke-[2.5]")} />
              <span className="text-[10px] font-medium">{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomTabBar;
